import React from 'react'
import './Loading.css';

function Loading() {
  return (
    <div className='loading-container'>
      <img src='https://uploads-ssl.webflow.com/63357010a5a26f4ec951d0e2/6336a976879cf733cb0c761f_Frame.svg' alt='Padam Mobility'/>
      <p>...Loading...</p>
    </div>
  )
}

export default Loading
